/**
 * src/lib/voice/voiceProposal.js — T2.3 chief-of-staff persistence.
 *
 * Supabase helpers for `voice_proposals`. One row per tool_proposal SSE
 * emitted by the voice agent. Insert on enqueue, update on resolve.
 *
 * Errors are swallowed (warn-only) — voice UX must not block on telemetry
 * writes. RLS is per-user so anonymous sessions are no-ops.
 */

export async function persistVoiceProposal({ supabase, proposal, sessionId }) {
  if (!proposal?.proposal_id) return;
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase
      .from('voice_proposals')
      .insert({
        proposal_id: proposal.proposal_id,
        session_id: sessionId || null,
        user_id: user.id,
        tool_name: proposal.name || 'unknown',
        args: proposal.args || {},
        spoken_summary: proposal.spoken_summary || null,
      });
  } catch (err) {
    console.warn('[voiceProposal] persist error:', err?.message);
  }
}

export async function resolveVoiceProposal({ supabase, proposalId, resolution }) {
  if (!proposalId) return;
  try {
    await supabase
      .from('voice_proposals')
      .update({
        resolved_at: new Date().toISOString(),
        resolution,
      })
      .eq('proposal_id', proposalId);
  } catch (err) {
    console.warn('[voiceProposal] resolve error:', err?.message);
  }
}
